import React from "react";
import { DocProps, DocMap } from "../../Language";
import { ModelAssumptionsSV as SV } from "./ModelAssumptionsSV";
import "../../Documents.css";

const docsMap: DocMap = { SV };

export const ModelAssumptions: React.FC<DocProps> = ({ language }) =>
  React.createElement(docsMap[language], null);
